import Vue from 'vue'
import Router from 'vue-router'
import BuyCourse from '@/components/BuyCourse'
import PackageHandBook from '@/components/PackageHandBook'
import MommySchoolCourse from '@/components/MommySchoolCourse'
import MommySchoolMarketing from '@/components/MommySchoolMarketing'
import FamilyHandBook from '@/components/FamilyHandBook'
import CastHelper from '@/components/CastHelper'
import ContentWithBottomAdvert from '@/components/ContentWithBottomAdvert'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/buyCourse',
      name: 'BuyCourse',
      component: BuyCourse,
      meta: {title: '解锁妈咪成长课堂'}
    },
    {
      path: '/packageHandBook',
      name: 'PackageHandBook',
      component: PackageHandBook,
      meta: {title: '玩转可可狮'}
    },
    {
      path: '/mommySchoolCourse',
      name: 'MommySchoolCourse',
      component: MommySchoolCourse,
      meta: {title: '全部课程'}
    },
    {
      path: '/mommySchoolMarketing',
      name: 'MommySchoolMarketing',
      component: MommySchoolMarketing,
      meta: {title: '可可狮妈咪成长课堂'}
    },
    {
      path: '/familyHandBook',
      name: 'FamilyHandBook',
      component: FamilyHandBook,
      meta: {title: ''}
    },
    {
      path: '/castHelper',
      name: 'CastHelper',
      component: CastHelper,
      meta: {title: '投屏助手'}
    },
    {
      path: '/contentWithBottomAdvert',
      name: 'ContentWithBottomAdvert',
      component: ContentWithBottomAdvert,
      meta: {title: ''}
    },
  ]


})





// WEBPACK FOOTER //
// ./src/router/index.js